import { Formik } from "formik";
import * as Yup from "yup";
import Input from "../../components/input";
import Button from "../../components/button";

import { doc, setDoc } from "firebase/firestore";
import { auth, db } from "src/firebase/firebase";
import { handleToastMessage } from "src/js/handleToastMessage";
import { v4 as uuidv4 } from "uuid";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword } from "firebase/auth";

const validationSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required."),
  lastName: Yup.string().required("Last name is required."),
  email: Yup.string().email().trim().required("Email is required."),
  addressLine1: Yup.string(),
  addressLine2: Yup.string(),
  ussdAddress: Yup.string(),
  password: Yup.string()
    .required("Password is required")
    .min(6, "Password is too short - should be 6 chars minimum."),
  confirmPassword: Yup.string().oneOf(
    [Yup.ref("password"), null],
    "Passwords must match"
  ),
});
const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  addressLine1: "",
  addressLine2: "",
  ussdAddress: "",
  password: "",
  confirmPassword: "",
};

const NewSupplier = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const addSupplier = (values: any) => {
    setIsLoading(true);
    createUserWithEmailAndPassword(auth, values.email, values.password)
      .then((userCredential) => {
        handleAddSupplier(values);
      })
      .catch((error) => {
        setIsLoading(false);
        switch (error.code) {
          case "auth/email-already-in-use":
            handleToastMessage("error", "Email already in use");
            break;
          default:
            break;
        }
        // ..
      });
  };

  const handleAddSupplier = async (values: any) => {
    setIsLoading(true);
    let _user = values;
    delete _user.password;
    delete _user.confirmPassword;
    _user.id = uuidv4();
    _user.accountType = "supplier";
    _user.date = new Date();
    _user.isEnable = true;
    await setDoc(doc(db, "Accounts", _user.id), _user);
    setIsLoading(false);
    handleToastMessage("success", "Account created successfully.");
    navigate("/admin");
  };

  return (
    <>
      <div className="p-5">
        <div className="flex justify-between items-center mb-3">
          <h2 className="text-xl text-darkBlack font-semibold">
            Supplier Management
          </h2>

          <div className="flex gap-x-2">
            <h4 className="cursor-pointer" onClick={() => navigate("/admin")}>
              {" "}
              Supplier Management /
            </h4>
            <span className="text-grey">Add New Supplier</span>
          </div>
        </div>
        <div className="pb-4 bg-white">
          <h2 className="text-xl text-darkBlack font-semibold py-2 px-5 border-b">
            Add Supplier
          </h2>
          <div className="p-5">
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={addSupplier}
              validateOnBlur
            >
              {({
                errors,
                touched,
                handleSubmit,
                handleBlur,
                handleChange,
                setFieldTouched,
                setFieldValue,
                values,
              }) => {
                return (
                  <form onSubmit={handleSubmit}>
                    <div className="p-2">
                      <div className="flex gap-2">
                        <Input
                          label="First Name"
                          className="flex-1"
                          placeholder="First Name"
                          name="firstName"
                          error={errors.firstName}
                          touched={touched.firstName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          variant="solid"
                        />
                        <Input
                          label="Last Name"
                          className="flex-1"
                          placeholder="Last Name"
                          name="lastName"
                          error={errors.lastName}
                          touched={touched.lastName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          variant="solid"
                        />
                      </div>
                      <div className="flex gap-2">
                        <Input
                          labelClassName="mt-3 text-base font-medium inline-block"
                          label="Password"
                          className="flex-1"
                          placeholder="Password"
                          name="password"
                          type="password"
                          error={errors.password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.password}
                          variant="solid"
                        />
                        <Input
                          labelClassName="mt-3 text-base font-medium inline-block"
                          label="Confirm Password"
                          className="flex-1"
                          placeholder="Confirm Password"
                          name="confirmPassword"
                          type="password"
                          error={errors.confirmPassword}
                          touched={touched.confirmPassword}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          variant="solid"
                        />
                      </div>
                      <Input
                        label="Email ID"
                        containerClass="w-full"
                        placeholder="Email"
                        name="email"
                        error={errors.email}
                        touched={touched.email}
                        onBlur={handleBlur}
                        value={values.email}
                        onChange={(e) => {
                          const value = e.target.value || "";
                          setFieldTouched("email", true);
                          setFieldValue("email", value.toLowerCase());
                        }}
                        variant="solid"
                      />
                      <Input
                        label="Address Line 1 (Optional)"
                        containerClass="w-full"
                        placeholder="Address line 1"
                        name="addressLine1"
                        error={errors.addressLine1}
                        touched={touched.addressLine1}
                        variant="solid"
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <Input
                        label="Address Line 2 (Optional)"
                        containerClass="w-full"
                        placeholder="Address line 2"
                        name="addressLine1"
                        error={errors.addressLine2}
                        touched={touched.addressLine2}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        variant="solid"
                      />
                      <Input
                        label="BTC/USSD Address (Optional)"
                        containerClass="w-full"
                        placeholder="BTC/USSD Address"
                        name="addressLine1"
                        error={errors.ussdAddress}
                        touched={touched.ussdAddress}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        variant="solid"
                      />
                    </div>
                    <div className="flex justify-end">
                      <Button
                        loading={isLoading}
                        type="submit"
                        className="ml-0 block  bg-blue mt-4 mb-3"
                      >
                        Add
                      </Button>
                    </div>
                  </form>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};
export default NewSupplier;
